import { ArrowUpRight, ArrowDownRight, Minus } from "lucide-react";

export function KpiCard({ label, value, delta, deltaLabel, hint, testid, tone = "default", right }) {
    const pos = typeof delta === "number" && delta > 0;
    const neg = typeof delta === "number" && delta < 0;

    return (
        <div
            data-testid={testid}
            className="hover-lift relative flex flex-col gap-2 rounded-sm border border-border bg-card p-4"
        >
            <div className="flex items-start justify-between">
                <div className="mlabel">{label}</div>
                {right}
            </div>
            <div className="flex items-baseline gap-2">
                <div className="mono-num text-2xl font-semibold tracking-tight text-foreground">{value}</div>
                {typeof delta === "number" && (
                    <span
                        className={
                            "flex items-center gap-0.5 text-[11px] font-medium " +
                            (pos
                                ? "text-emerald-600"
                                : neg
                                ? "text-red-500"
                                : "text-muted-foreground")
                        }
                    >
                        {pos ? (
                            <ArrowUpRight className="h-3 w-3" />
                        ) : neg ? (
                            <ArrowDownRight className="h-3 w-3" />
                        ) : (
                            <Minus className="h-3 w-3" />
                        )}
                        {Math.abs(delta).toFixed(1)}%
                        {deltaLabel && <span className="ml-1 text-muted-foreground">{deltaLabel}</span>}
                    </span>
                )}
            </div>
            {hint && <div className="text-[11px] text-muted-foreground">{hint}</div>}
            {tone === "ai" && (
                <span className="absolute right-2 top-2 rounded-sm border border-[hsl(var(--ai))]/30 bg-[hsl(var(--ai))]/[0.08] px-1.5 py-[1px] text-[9px] font-semibold uppercase tracking-wider text-[hsl(var(--ai))]">
                    AI
                </span>
            )}
        </div>
    );
}
